import { useMemo } from "react";
import useUser from "./useUser";
import useCrew from "./useCrew";
import { UserRoles, Crew } from "../services/authorization";
import { MyInfoResponse } from "../api/user";

const useUserRoles = (): UserRoles => {
  const user = useUser() as MyInfoResponse | null;
  const { crew } = useCrew() as { crew: Crew };

  // Only computed roles - actual API roles are checked directly in authorization service
  const roles = useMemo((): UserRoles => {
    if (!user || !crew) {
      return {
        isCrewAdmin: false,
        isSuperAdmin: false,
      };
    }

    if (crew.id === 0) {
      return {
        isCrewAdmin: true,
        isSuperAdmin: true,
      };
    }

    const currentCrew = user.crews?.find((c) => c.id === crew.id);

    if (!currentCrew) {
      return {
        isCrewAdmin: false,
        isSuperAdmin: user.sa || false,
      };
    }

    const isCrewAdmin = (): boolean => {
      return currentCrew.admin === true;
    };

    return {
      isCrewAdmin: isCrewAdmin(),
      isSuperAdmin: user.sa || false,
    };
  }, [user, crew]);

  return roles;
};

export default useUserRoles;
